import { render } from "./DeleteCurrentCar.vue?vue&type=template&id=e03bfd7c&scoped=true"
import script from "./DeleteCurrentCar.vue?vue&type=script&lang=js"
export * from "./DeleteCurrentCar.vue?vue&type=script&lang=js"

import "./DeleteCurrentCar.vue?vue&type=style&index=0&id=e03bfd7c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\vue_php_crud\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e03bfd7c"]])

export default __exports__